export enum CommentStatus
{
    Active,
    Deleted,
    Edited,
    Removed
}